import React from 'react';
//Iconos
import DashboardIcon from '@material-ui/icons/Dashboard';
import HomeIcon from '@material-ui/icons/Home';
import Note from '@material-ui/icons/Note';
import GroupIcon from '@material-ui/icons/Group';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import HeadsetMicIcon from '@material-ui/icons/HeadsetMic';
import EventIcon from '@material-ui/icons/Event';
import AssessmentIcon from '@material-ui/icons/Assessment';

const inicio = {
   title: 'Inicio',
   icon: <HomeIcon />,
   href: '/home',
   pages: []
};

const mantenimientos = {
   title: 'Datos',
   icon: <DashboardIcon />,
   pages: [
      {
         title: 'Abrir Ticket',
         href: '/abrirTicket',
         icon: <ConfirmationNumberIcon />,
         hidden: {
            prod: true,
            dev: true
         }
      },
      {
         title: 'Perfil',
         href: '/perfil',
         icon: <GroupIcon />
      }
   ]
};

const reportes = {
   title: 'Reportes',
   icon: <Note />,
   pages: [
      {
         title: 'Lista Ticket',
         href: '/listaTicket',
         icon: <ConfirmationNumberIcon />
      },
      {
         title: 'Capacitaciones',
         href: '/Capacitaciones',
         icon: <ConfirmationNumberIcon />
      }
   ],
   hidden: {
      prod: true,
      dev: true
   }
};

const procesos = {
   title: 'Procesos',
   icon: <Note />,
   pages: [
      {
         title: 'Dashboard',
         href: '/dashboard',
         icon: <DashboardIcon />
      }
   ],
   hidden: {
      prod: true,
      dev: true
   }
};

const atenciones = {
   title: 'Atención',
   icon: <HeadsetMicIcon/>,
   pages: [
      {
         title: 'Programar soporte',
         href: '/programarAtencion',
         icon: <EventIcon/>
      },
      {
         title: 'Reporte atención',
         href: '/reporteAtencion',
         icon: <AssessmentIcon/>
      }
   ]
}

export { inicio, mantenimientos, reportes, procesos, atenciones };
